var map = {
	"./E06-cn-arup-climate-risk-images.jpg": "5721",
	"./E06-en-arup-climate-risk-images.jpg": "fc77",
	"./MASTER_CHN_VP_Handbook_Web1.jpg": "0ad4",
	"./MASTER_CHN_VP_Handbook_Web10.jpg": "da88",
	"./MASTER_CHN_VP_Handbook_Web11.jpg": "8ad5",
	"./MASTER_CHN_VP_Handbook_Web12.jpg": "9ac7",
	"./MASTER_CHN_VP_Handbook_Web13.jpg": "91d9",
	"./MASTER_CHN_VP_Handbook_Web14.jpg": "0895",
	"./MASTER_CHN_VP_Handbook_Web15.jpg": "86f5",
	"./MASTER_CHN_VP_Handbook_Web16.jpg": "3c3e",
	"./MASTER_CHN_VP_Handbook_Web17.jpg": "76d7",
	"./MASTER_CHN_VP_Handbook_Web18.jpg": "7f45",
	"./MASTER_CHN_VP_Handbook_Web19.jpg": "d22f",
	"./MASTER_CHN_VP_Handbook_Web2.jpg": "4415",
	"./MASTER_CHN_VP_Handbook_Web20.jpg": "8822",
	"./MASTER_CHN_VP_Handbook_Web21.jpg": "b8a7",
	"./MASTER_CHN_VP_Handbook_Web22.jpg": "d965",
	"./MASTER_CHN_VP_Handbook_Web23.jpg": "1f62",
	"./MASTER_CHN_VP_Handbook_Web24.jpg": "1c07",
	"./MASTER_CHN_VP_Handbook_Web25.jpg": "63df",
	"./MASTER_CHN_VP_Handbook_Web26.jpg": "5a0d",
	"./MASTER_CHN_VP_Handbook_Web27.jpg": "41ea",
	"./MASTER_CHN_VP_Handbook_Web28.jpg": "59f4",
	"./MASTER_CHN_VP_Handbook_Web29.jpg": "2f95",
	"./MASTER_CHN_VP_Handbook_Web3.jpg": "89c3",
	"./MASTER_CHN_VP_Handbook_Web30.jpg": "b8d7",
	"./MASTER_CHN_VP_Handbook_Web31.jpg": "9fdb",
	"./MASTER_CHN_VP_Handbook_Web32.jpg": "d0668",
	"./MASTER_CHN_VP_Handbook_Web33.jpg": "a3d3",
	"./MASTER_CHN_VP_Handbook_Web34.jpg": "825b",
	"./MASTER_CHN_VP_Handbook_Web35.jpg": "7461",
	"./MASTER_CHN_VP_Handbook_Web4.jpg": "af99",
	"./MASTER_CHN_VP_Handbook_Web5.jpg": "048a",
	"./MASTER_CHN_VP_Handbook_Web6.jpg": "e7ae",
	"./MASTER_CHN_VP_Handbook_Web7.jpg": "41cd",
	"./MASTER_CHN_VP_Handbook_Web8.jpg": "e1f3",
	"./MASTER_CHN_VP_Handbook_Web9.jpg": "ac67",
	"./MASTER_ENG_VP_Handbook_Web1.jpg": "2d67",
	"./MASTER_ENG_VP_Handbook_Web10.jpg": "409c",
	"./MASTER_ENG_VP_Handbook_Web11.jpg": "3cc4",
	"./MASTER_ENG_VP_Handbook_Web12.jpg": "904e",
	"./MASTER_ENG_VP_Handbook_Web13.jpg": "b655",
	"./MASTER_ENG_VP_Handbook_Web14.jpg": "eb35",
	"./MASTER_ENG_VP_Handbook_Web15.jpg": "88b3",
	"./MASTER_ENG_VP_Handbook_Web16.jpg": "7ac1",
	"./MASTER_ENG_VP_Handbook_Web17.jpg": "dec7",
	"./MASTER_ENG_VP_Handbook_Web18.jpg": "df26",
	"./MASTER_ENG_VP_Handbook_Web19.jpg": "8cb4",
	"./MASTER_ENG_VP_Handbook_Web2.jpg": "320b",
	"./MASTER_ENG_VP_Handbook_Web20.jpg": "5d4f",
	"./MASTER_ENG_VP_Handbook_Web21.jpg": "cc5b",
	"./MASTER_ENG_VP_Handbook_Web22.jpg": "7a8c",
	"./MASTER_ENG_VP_Handbook_Web23.jpg": "f165",
	"./MASTER_ENG_VP_Handbook_Web24.jpg": "7634",
	"./MASTER_ENG_VP_Handbook_Web25.jpg": "d734",
	"./MASTER_ENG_VP_Handbook_Web26.jpg": "2b70",
	"./MASTER_ENG_VP_Handbook_Web27.jpg": "1296",
	"./MASTER_ENG_VP_Handbook_Web28.jpg": "5ee7",
	"./MASTER_ENG_VP_Handbook_Web29.jpg": "e48f",
	"./MASTER_ENG_VP_Handbook_Web3.jpg": "f3ca",
	"./MASTER_ENG_VP_Handbook_Web30.jpg": "9e2b",
	"./MASTER_ENG_VP_Handbook_Web31.jpg": "2b6d",
	"./MASTER_ENG_VP_Handbook_Web32.jpg": "5eaa",
	"./MASTER_ENG_VP_Handbook_Web33.jpg": "e894",
	"./MASTER_ENG_VP_Handbook_Web34.jpg": "f8a4",
	"./MASTER_ENG_VP_Handbook_Web35.jpg": "2716",
	"./MASTER_ENG_VP_Handbook_Web4.jpg": "c8bb",
	"./MASTER_ENG_VP_Handbook_Web5.jpg": "c9b7",
	"./MASTER_ENG_VP_Handbook_Web6.jpg": "d2ce",
	"./MASTER_ENG_VP_Handbook_Web7.jpg": "3a70",
	"./MASTER_ENG_VP_Handbook_Web8.jpg": "d2f8",
	"./MASTER_ENG_VP_Handbook_Web9.jpg": "7228",
	"./Picture3.jpg": "b2d6",
	"./about-banner.jpg": "13f2",
	"./about.jpg": "bc25",
	"./arup.jpg": "ac04",
	"./banner-fixed.jpg": "398e",
	"./banner.jpg": "301c",
	"./briefing-1.jpg": "d08a",
	"./briefing-2.jpg": "f790",
	"./briefing-3.jpg": "e23c",
	"./briefing-4.jpg": "f1bb",
	"./briefing-5.jpg": "28c3",
	"./briefing-banner.jpg": "23e1",
	"./briefing.jpg": "3a2a",
	"./catalogue-banner.jpg": "5ff9",
	"./catalogue.jpg": "9b75",
	"./cma-logo.png": "86ca",
	"./cn-flag.png": "ff21",
	"./demonstrators-banner.jpg": "f44c",
	"./demonstrators.jpg": "e501",
	"./en-flag.png": "2ba5",
	"./explainer-1.jpg": "a1d7",
	"./explainer-10.jpg": "ef5a",
	"./explainer-11.jpg": "6514",
	"./explainer-12.jpg": "e1e1",
	"./explainer-13.jpg": "8dc4",
	"./explainer-14.jpg": "f220",
	"./explainer-15.jpg": "db88",
	"./explainer-16.jpg": "5b66",
	"./explainer-17.jpg": "02a0",
	"./explainer-18.jpg": "e2a5",
	"./explainer-2.jpg": "5577",
	"./explainer-3.jpg": "3fee",
	"./explainer-4.jpg": "7209",
	"./explainer-5.jpg": "783d",
	"./explainer-6.jpg": "f3f0",
	"./explainer-7.jpg": "92a6",
	"./explainer-8.jpg": "74b5",
	"./explainer-9.jpg": "b63b",
	"./explainers-banner.jpg": "c80c",
	"./explainers.jpg": "45dd",
	"./glossary-banner.jpg": "5ae3",
	"./glossary.jpg": "0c77",
	"./handbook.jpg": "1d37",
	"./iap-logo.png": "35fb",
	"./iea-logo.png": "f175",
	"./infographic-1-cn.jpg": "63f6",
	"./infographic-1.jpg": "af6c",
	"./infographic-2-cn.jpg": "14ed",
	"./infographic-2.jpg": "04ca",
	"./infographic-3-cn.jpg": "67f6",
	"./infographic-3.jpg": "6709",
	"./infographic-4.jpg": "7ef6",
	"./infographic-5.jpg": "d8f6",
	"./infographics-banner.jpg": "9a26",
	"./infographics.jpg": "15da",
	"./logo.png": "9d64",
	"./mo-logo.png": "20ef",
	"./nf-logo.png": "0771",
	"./qump.jpg": "54fe",
	"./resources-banner.jpg": "430f",
	"./resources.jpg": "1653",
	"./suhi-laptop.jpg": "2ddf",
	"./training-banner.jpg": "b84b",
	"./training.jpg": "e86b",
	"./umep.jpg": "9c41",
	"./verdant-laptop.jpg": "9e4d",
	"./videos-banner.jpg": "5ddd",
	"./videos.jpg": "b078",
	"./wrm-laptop.jpg": "c33c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";